import React, { useEffect, useState } from "react";
import XCard from "../XCard";
import axios from "../../services/axios";
import { Modal } from "antd";
import { useHistory } from "react-router-dom";
import {
  changeDateTimeFormat,
  formatDateDDMMYYYY
} from "../../utils/commonFunctions";
import { RollbackOutlined } from "@ant-design/icons";
import messages from "../../services/message";
import axios_dev from "axios";
import BASE from "../../config";
import swal from "sweetalert";
import LoadingArea from "../LoadingArea";
import useAxios from "../../hooks/useAxios";

const FormList = ({
  formList,
  id,
  getDoc,
  getFormList,
  candidate,
  formData,
  canSendNonAgentDocs
}) => {
  const api = useAxios()
  const [formID, setFormID] = useState("");
  const [toggle, setToggle] = useState(false);
  const [candidateDocs, setCandidateDocs] = useState([]);
  const history = useHistory();
  const [joiningDate, setJoiningDate] = useState(null);
  const [bulkSend, setBulkSend] = useState([]);
  const [loading, setLoading] = useState(false);

  const onClickSend = () => {
    setLoading(true);
    axios
      .post(
        "candidateDocuments",
        {
          candidateId: id,
          candidateDocumentList: bulkSend
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`
          }
        }
      )
      .then( async (res) => {
        await getDoc()
        setBulkSend([]);
        handleOk();
        messages("Form sent, successfully!", "success", 5);
      })
      .catch((err) => {
        console.error(err.response.data.error)
        messages(err.response.data.error, "error", 5);
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleDateChange = (e) => {
    console.log(e.target.value);
  };

  const bulkSendHandler = (e, _id) => {
    if (e.target.checked) {
      setBulkSend([...bulkSend, _id]);
    } else {
      setBulkSend([...bulkSend.filter((id) => id !== _id)]);
    }
  };

  const onClickRollBack = async (_id) => {

    const flag = await swal({
      title: "Are you sure?",
      text: "You want to pull back this Form?",
      icon: "warning",
      buttons: {
        cancel: true,
        confirm: true
      }
    })

    if(!flag) return

    try{
      setLoading(true)
      await api.put(`/candidateDocuments/pullBackDocuments/${_id}`,{},{tokenType : 'user'})
      await getDoc()
    }catch(err) {
      console.error(err)
    }finally{
      setLoading(false)
    }
  };

  return (
    <>
      <LoadingArea isLoading={loading}>
        <div className="table-responsive">
          <table id="table-datatable" className="table bg-white">
            <thead className="table-head">
              <tr>
                <td>Form Name</td>
                <td>Sent On</td>
                <td>
                  <div className="d-flex justify-content-center align-items-center">
                    Select
                  </div>
                </td>
                <td>
                  <div className="d-flex justify-content-center align-items-center">
                    Pull back
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              {formData?.map((ele, index) => {
                return (
                  <tr>
                    <td>{ele.name}</td>
                    <td>
                      {ele.sentStatus
                        ? formatDateDDMMYYYY(new Date(ele.sentOn))
                        : ""}
                    </td>
                    <td>
                      <div className="d-flex justify-content-center align-items-center">
                        <input
                          type="checkbox"
                          name="doc"
                          disabled={
                            (ele.sentStatus || candidate?.documentsVerifiedStatus || candidate?.isEmpTempIdCreated) || !canSendNonAgentDocs
                          }
                          checked={bulkSend.includes(ele?._id) || ele.sentStatus}
                          onChange={async (e) => {
                            if(candidate?.trf?.isTRFApproved !== true || candidate?.trf?.Status === false){
                                 return swal({
                                  title: "",
                                  text: "You cannot proceed with the document as the TRF is either under process or rejected or inactive.",
                                  icon: "error",
                                  buttons: {
                                    cancel: false,
                                    confirm: true
                                  }
                                })
                            }
                            bulkSendHandler(e, ele?._id)}}
                          style={{ transform: "scale(1.3)" }}
                        />
                      </div>
                    </td>
                    <td>
                      <div className="d-flex justify-content-center align-items-center">
                        {ele.sentStatus === true &&
                          ele.isFilledStatus === false && (
                            <>
                              <span
                                style={{
                                  display: "block",
                                  border: "1px solid red",
                                  padding: "0 0.5rem",
                                  borderRadius: "50%"
                                }}
                                onClick={() => onClickRollBack(ele?.docId)}>
                                <RollbackOutlined
                                  style={{
                                    fontSize: "1rem",
                                    cursor: "pointer",
                                    color: "red",
                                    fontWeight: "800"
                                  }}
                                />
                              </span>
                            </>
                          )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {canSendNonAgentDocs && (
            <div className="d-flex justify-content-center align-items-center">
              <button
                className={`btn ${
                  bulkSend.length === 0 || candidate?.documentsVerifiedStatus
                    ? "btn-secondary"
                    : "btn-primary"
                } btn-sm mr-1`}
                disabled={
                  bulkSend.length === 0 || candidate?.documentsVerifiedStatus
                }
                onClick={() => onClickSend()}>
                Send
              </button>
            </div>
          )}
        </div>
      </LoadingArea>

      <Modal
        title="Action"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={
          <button
            className="btn btn-info btn-sm mr-1"
            onClick={() => onClickSend()}
            data-target="#sendModal"
            data-toggle="modal"
            // disabled={ele?.isFormAlreadySent ? true : false}
          >
            <i class="fa fa-paper-plane" aria-hidden="true"></i>
            {/* {ele?.isFormAlreadySent ? " Sent" : " Send"} */} Send
            {/* If DOJ then Send If not then Submit */}
          </button>
        }>
        <div class="col-md-12">
          <label for="">Date of joining*</label>
          <input
            class="form-control form-view"
            type="date"
            onChange={handleDateChange}
            placeholder="Enter Input Element here..."
            label="Name"
            value={joiningDate}
          />
        </div>
      </Modal>
    </>
  );
};

export default FormList;
